module.exports = __webpack_public_path__ + "static/media/ini1-270w.90358107.jpg";